//$('#widget').draggable();

function stripHTML(dirtyString) {
    var container = document.createElement('div');
    container.innerHTML = dirtyString;
    return container.textContent || container.innerText;
}

function getHash() {
	var ratio = 1;
	var _hash = window.location.hash;
	if(_hash.length === 0){
		_hash = window.location.search;
	}
	_hash = _hash.substring(1);
	var arr = _hash.split("&");
	try{ _hash.split("&"); }catch(e){};
	try{arr[0] = new Array(arr[0].split("="));}catch(e){};
	try{arr[1] = new Array(arr[1].split("="));}catch(e){};
	var ln = arr.length;
	for(var i = 0; i < ln; i++){
		if(arr[i][0][0] === "W"){
			ratio = parseInt(arr[i][0][1])/800;
		}
	}
	var cssObj = {
		'zoom':ratio,
		'-moz-transform': 'scale('+ratio+')',
		'-moz-transform-origin' : '0 0',
		'-o-transform': 'scale('+ratio+ ', '+ratio+')',
		'-o-transform-origin': '0 0'
	};
	$("body").css(cssObj);
}


/* UTILS */

function getKeys(obj) {
    var r = []
    for (var k in obj) {
        if (!obj.hasOwnProperty(k))
            continue
        r.push(k)
    }
    return r
};

Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

var indexOf = function(arr, key) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] === key) {
      return i;
    }
  }
}

function changeBG(bgNew) {
	var bg = $("#bg").attr("class");
	$("#bg").removeClass( bg ).addClass( bgNew );
}

function bannerReset () {
	TweenMax.to('.banner1', 0, {autoAlpha:0});
	TweenMax.to('.banner1', 1, {x:0, y:0,  ease:Quint.easeOut});
  TweenMax.to('.banner2', 0, {autoAlpha:0});
	TweenMax.to('.banner2', 1, {x:0, y:0,  ease:Quint.easeOut});
  TweenMax.to('.banner3', 0, {autoAlpha:0});
	TweenMax.to('.banner3', 1, {x:0, y:0,  ease:Quint.easeOut});
  TweenMax.to('.banner4', 0, {autoAlpha:0});
	TweenMax.to('.banner4', 1, {x:0, y:0,  ease:Quint.easeOut});
}

function slideReset () {
  $(".slide").html('');
  $(".slide").fadeOut(200);
  $("#banner_box").html('');
}

function loadBanners(idBanner,promena) {
  /* banners */
  var bmcont = '';
  var pricti = 0;
  bmcont = $("#banner_box").html();
  $("#banner_box").removeClass();
  pocet = jsondata[promena].length;
  for (i=0; i<pocet; i++) {
    pricti = pricti + 1;
    bmcont += '<div id=\"ban_'+idBanner+'_'+pricti+'\" class=\"banner'+idBanner+'\"><div class=\"banner_plocha\">'+jsondata[promena][i]+'</div><div class=\"banner_close\"></div></div>';
  }
  $("#banner_box").html(bmcont);
}


function top_menu() {
  mfcont = '<ul id="menu_top">';
	pocet = jsondata['MENU_LABEL'].length + 1
  for (i=1; i<pocet; i++) {
		mfcont += '<li id="tmi'+i+'" class="tmi">'+jsondata.MENU_LABEL[(i-1)]+'</li>'
	}
	mfcont += '</ul>';

	mapa = '<div id="bg" class="bg1"></div>';

	$(mfcont).appendTo("#mainframe");
  $(mapa).appendTo("#mainframe");
	mfcont = ''; mapa ='';

  $(".tmi").on("click",function(){
  	var idMenu = $(this).attr("id");
  	console.log(idMenu)
  	switch (idMenu) {
  		case "tmi1":
  		slide1_anima();
  		break;
  		case "tmi2":
  		slide2_anima();
  		break;
  		case "tmi3":
  		slide3_anima();
  		break;
  	};
  });
}

function Element(id, banner, point) {
		this.id = id;
		this.banner = banner;
		this.point = point;
		this.appendPoint = function (scene) {

			$(this.point).appendTo(scene);
		}
}

function isEmpty(obj) { // credits http://stackoverflow.com/questions/4994201/is-object-empty

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var k in obj) {
        if (obj.hasOwnProperty(k)) return false;
    }

    return true;
}

function CreateElements1(data1) {

	$.each(data1, function(key, val) {


			var point = "<div class='circle_pos' id='circle_pos_"+key+"' data-clicked='"+key+"'>";
			point += "<div class='circle_leash' id='circle_leash_"+key+"'></div>";
			point += "<div class='circle_label' id='circle_label_"+key+"'>"+val.label+"</div>";
			point += "<div class='circle_bg'></div>";
			point += "<div class='circle_anim pulsateME'></div>";
			point += "<div class='circle' id='circle_"+key+"' data-clicked='"+key+"'></div>";
			point += "<div class='circle_over' id='circle_over_"+key+"' data-clicked='"+key+"'></div>";
			point += "</div>";

			var banner = val.text;

			window.elements1[key] = new Element(key, banner, point);
	});
}

function appendThisPoint(elvar, el, obj) {

	window[elvar][el].appendPoint(obj);
}

function appendThesePoints(elvar, els, obj) {

	$.each(els, function( key, val ) {
		window[elvar][val].appendPoint(obj);
	});
}
/*
function startBox(top) {
  $( "#slide1Start" ).fadeIn( "slow", function() {
  });
  var helpBox = document.getElementById("startBox");
  TweenMax.to(helpBox, 1, {x:0, y:top,  ease:Quint.easeOut});
  TweenMax.to(helpBox, 0.5, {autoAlpha:1});
}
*/
function returnHome(idTlac,idVrstva) {
  $(idTlac).on("click", function() {
    $("#banner_box").html('');
    $(idVrstva).html('');
  	$(idVrstva).fadeOut( "slow", function() { });
  });
}

function clickBanner(id,clickid) {
	/*$('.ref').on("click", function() {
		$('li.ref', $(this).parent()).removeClass('active');
		$(this).addClass('active');
		TweenMax.to('.banner', 0, {autoAlpha:0});
		TweenMax.to('.banner', 1, {x:0, y:0,  ease:Quint.easeOut});
		var id_banner = $(this).attr("id");
		var bannerBox = document.getElementById("ban_"+id_banner);
		TweenMax.to(bannerBox, 1, {x:0, y:-400,  ease:Quint.easeOut});
		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
	});*/
	$('.banner_close').on("click", function() {
		TweenMax.to('.banner'+clickid, 1, {x:0, y:0,  ease:Quint.easeOut});
		TweenMax.to('.banner'+clickid, 0.5, {autoAlpha:0});

    switch (clickid) {
    case 1:
      $("#"+id+" .circle_bg").show();
      $("#"+id+" .circle_anim").show();
      $("#circle_"+clickid).removeClass("active");
      $("#circle_"+clickid+" .icon-"+clickid).removeClass("active");
    break;
    case 3:
      $(".bmi_small .bmi_bg_small_active").hide();
      $(".bmi_small .bmi_point_small").show();
      $(".bmi_small .bmi_bg_small").fadeIn(300);

      $("#"+id+" .circle_bg").fadeIn(300);
      $("#"+id+" .circle_anim").show();
      $("#circle_2").removeClass("active");
      $("#circle_2 .icon-4").removeClass("active");
    break;
    case 22:
      //$("#"+id+" .circle_bg").show();
      //$("#"+id+" .circle_anim").show();
      //$("#circle_"+clickid).removeClass("active");
      //$("#circle_"+clickid+" .icon-"+clickid).removeClass("active");
    break;
    case 4:
      console.log(id);
      console.log(clickid);
      $(".lecba .icons").removeClass("active");
      //$("#"+id+" .circle_bg").show();
      //$("#"+id+" .circle_anim").show();
      //$("#circle_"+clickid).removeClass("active");
      //$("#circle_"+clickid+" .icon-"+clickid).removeClass("active");
    break;
    };

	});
}
